module.exports = __webpack_public_path__ + "static/img/a2ca2d9ce6571f5fa699fcc28e7bdf5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceMap/images/connected.svg
// module id = 2762
// module chunks = 1